import React from "react";

const CustomLoader = ({ text, logo }) => {
  const imgSrc = logo || "";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
        textAlign: "center", 
        width: "100%",        
      }}
    >
      <style>
        {`
          @keyframes custom-loader-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>

      {imgSrc && (
        <img
          src={imgSrc}
          alt="company-logo"
          style={{ width: 120, height: "auto" }}
        />
      )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
          }}
        >
          <div
            style={{
              width: "38px",
              height: "38px",
              border: "4px solid var(--theme-loader-track, #d9e6ef)",
              borderTop: "4px solid var(--theme-loader-accent, #1F4670)",
              borderRadius: "50%",
              animation: "custom-loader-spin 0.85s linear infinite",
            }}
          />
          <span
            style={{
            fontSize: "1.2rem",
            fontWeight: "520",
            textAlign: "center",
            wordBreak: "break-word", 
            color: "var(--theme-loader-accent, #1F4670)",
            fontFamily: "'Poppins', sans-serif",
            }}
          >
            {text || "Cargando..."}
          </span>
        </div>
      </div>
  );
};

export default CustomLoader;
